export enum Language {
  finnish = 'fi-FI',
  swedish = 'sv-FI',
  english = 'en-FI',
}

export const getCurrentLanguage = (): Language => {
  // Read language from URL parameters
  const urlParams = new URLSearchParams(window.location.search)
  const langParam = urlParams.get('lang')

  if (langParam && Object.values(Language).includes(langParam as Language)) {
    return langParam as Language
  }

  // Add support for Abitti 1 (language codes are 'fi-FI' and 'sv-SE')
  const browserLanguage = navigator.language.toLowerCase()
  if (browserLanguage.startsWith('sv')) {
    return Language.swedish
  }

  // Default to Finnish if no valid language parameter
  return Language.finnish
}

const toggleLanguageElements = (activeLanguage: Language) => {
  const wrongLanguageElements = document.querySelectorAll(`[lang]:not([lang='${activeLanguage}'])`)
  wrongLanguageElements.forEach((element) => element.classList.add('hidden'))

  const correctLanguageElements = document.querySelectorAll(`[lang='${activeLanguage}']`)
  correctLanguageElements.forEach((element) => element.classList.remove('hidden'))
}

export const initializeLanguage = () => {
  toggleLanguageElements(getCurrentLanguage())
}
